import { useWindowSize as s } from "./useWindowSize.js";
import { PRODUCT_ICON_HEIGHT as T, PRODUCT_ICON_GAP_HEIGHT as u, LOGO_HEIGHT as _, PADDING_TOP_HEIGHT as i, PADDING_BOTTOM_HEIGHT as l, EXTRA_PADDING_BOTTOM_UL as D } from "../components/Sidebar/helpers.js";
const H = (r) => {
  const o = r - (_ + i + l + D);
  return Math.floor(o / (T + u));
}, a = (r) => {
  const {
    height: o
  } = s();
  if (!o)
    return {
      showMore: !1,
      numberToDisplay: null
    };
  const e = H(o), t = e < r, n = t ? e - 1 : e;
  return {
    showMore: t,
    numberToDisplay: n
  };
};
export {
  a as useSidebarSlot
};
